import { usePostHog } from "@posthog/react";
import { useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";

export function NotFoundComponent() {
  const router = useRouterState();

  const notFoundElement = (
    <div style={{ padding: "1em" }}>
      <p>
        Requested resource `{router.location.pathname}` not found. Redirecting
        to the <a href="/">main page</a>.
      </p>
    </div>
  );

  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture("Not found", { location: router.location });
    const timeout = setTimeout(() => (window.location.href = "/"), 2000);
    return () => clearTimeout(timeout);
  }, [posthog, router.location]);

  return notFoundElement;
}
